import $ from 'jquery';

export default function() {
    this.incrementCount = function(attr) {
        this.select(attr).each(function() {
            var $el = $(this);
            var count = parseInt($el.text(), 10);
            count = count || 0;
            $el.text(count + 1);
        });
    };

    this.decrementCount = function(attr) {
        this.select(attr).each(function() {
            var $el = $(this);
            var count = parseInt($el.text(), 10);
            count = count || 0;
            if (count > 0) {
                $el.text(count - 1);
            } else {
                $el.text(count);
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/web/js/app/mixins/with-counter.js